/**
 * @file 获取关注文档评论状态
 */
import {useEffect, useState, useCallback, useMemo} from 'react';

import toast, {ToastType} from '@/components/Toast';
import {getMorphoService, serviceNames} from '@/rte/editor';
import sdk from '@/sdk';

interface Options {
    docGuid: string;
    curDocument?: WizDocument;
    curRepository?: Repository;
}

export const useCommentFollow = ({
    docGuid,
    curDocument,
    curRepository,
}: Options) => {

    const [commentDefaultChecked, setCommentDefaultChecked] = useState<boolean>(false);

    // 修改编辑器关注评论状态
    const setCommentChecked = (checked: boolean) => {
        try {
            const commentService = getMorphoService(serviceNames.ICommentService);
            commentService.state.isFollowDocComment.next(checked);
        } catch (error) {
            console.log(error);
        }
    };

    const initSwitchValue = useCallback(async () => {
        if (!curRepository || !curDocument || window.isTocPage) {
            return false;
        }
        try {
            const docGuid = curDocument.docGuid;
            const res = await sdk.as.getAttentionDocDynamics(docGuid);
            setCommentDefaultChecked(res.commentStatus === 1);
            setCommentChecked(res.commentStatus === 1);
        } catch (error) {
            console.log(error);
        }
    }, [curDocument, curRepository]);

    useEffect(() => {
        initSwitchValue();
    }, [initSwitchValue]);


    const onMentionSwitchValueChange = useCallback(async (
        sheetMentionStatus: boolean,
        type: string
    ) => {
        try {
            if (sheetMentionStatus) {
                await sdk.as.addAttentionDocDynamics(docGuid, type);
                toast({
                    type: ToastType.Success,
                    content: '关注成功，评论动态会在「如流服务号」通知你',
                });
            } else {
                await sdk.as.cancelAttentionDocDynamics(docGuid, type);
                toast({
                    type: ToastType.Success,
                    content: '已取消',
                });
            }

            setCommentChecked(sheetMentionStatus);
            return sheetMentionStatus;
        }
        catch (error) {
            console.log(error);
            return !sheetMentionStatus;
        }
    }, [docGuid]);

    return {
        onMentionSwitchValueChange,
        commentDefaultChecked,
    };
};
